import { b as d } from "./withEditable-7d0a220a.js";
import { jsx as i, jsxs as T } from "react/jsx-runtime";
import { AuthoringUtils as h } from "@adobe/aem-spa-page-model-manager";
import { Tabs as r } from "@ucl/react-library/tabs";
import { useMemo as E } from "react";
import "html-react-parser";
import "sanitize-html";
import { s as f } from "./sanitizeProps-304c699d.js";
import { E as u } from "./EditableFlexContainer-4e9217f9.js";
import "@adobe/aem-react-editable-components";
import "./PageContext-57b2437f.js";
import "./component-a7888ba1.js";
import "./EditableComponentUtils-0b5699b7.js";
import "@ucl/react-library/useIsMounted";
import "./ComponentContext-3bb2d205.js";
import "./withErrorBoundary.js";
import "@ucl/shared-component-foundations/foundations";
import "styled-components";
import "./index-0371017d.js";
import "@ucl/shared-component-foundations";
import "./hooks.js";
import "./useViewPortProps-0c0b5cc6.js";
import "@ucl/react-library/useMediaQuery";
const n = ({ tabHeaderItems: t = [], tabContent: m = [], bottomBorderFullWidth: c, tabContentClassName: p, ...e }) => {
  const s = t.findIndex((a) => a.activeTab === "true"), l = s !== -1 ? s : 0, b = E(() => h.isInEditor(), []);
  return /* @__PURE__ */ i("div", {
    children: /* @__PURE__ */ T(r, {
      activeTab: l,
      isBottomBorderFullWidth: c,
      ...f(e),
      children: [
        /* @__PURE__ */ i(r.List, {
          children: t.map((a, o) => /* @__PURE__ */ i(r.List.Item, {
            children: a.label
          }, `tab_${o}`))
        }),
        /* @__PURE__ */ i(r.Panel, {
          children: t.map((a, o) => /* @__PURE__ */ i(r.Panel.Content, {
            className: p,
            children: m[o] || /* @__PURE__ */ i(u, {
              name: `tab_content_${o}`,
              parentCqPath: e.cqPath,
              parentCqItems: e.cqItems,
              isInEditor: b
            })
          }, o))
        })
      ]
    })
  });
};
n.displayName = "Tabs";
const C = (t) => {
  var m;
  return !((m = t == null ? void 0 : t.tabHeaderItems) != null && m.length);
}, P = "ucl/components/tabs", _ = {
  emptyLabel: "Tabs",
  isEmpty: C,
  resourceType: P
}, D = d(_, n);
export {
  D as EditableTabs,
  P as TABS_RESOURCE_TYPE
};
